/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   08/11/2022
 */

import React from "react";
import { Link, Stack, TextField } from "@mui/material";
import { UseFormReturnType } from "@mantine/form";
import { CalendarSettingsForm } from "./CalendarSettingsDialog";
import { Calendar } from "../interfaces/Global";
import ModelView from "../components/ModelView";
import { useSelector } from "react-redux";
import { State } from "../state/store";

export interface CalendarSettingsGeneralProps {
	form: UseFormReturnType<CalendarSettingsForm>
	savedCalendar?: Calendar | null
}

export default function CalendarSettingsGeneral({ form, savedCalendar }: CalendarSettingsGeneralProps) {

	const calendar = useSelector((s:State) => s.calendar);

	return (
		<Stack>
			<TextField
				variant={"standard"}
				label={"Calendar Title"}
				{...form.getInputProps("title", { withError: false })}
				error={!!form.errors.title}
				helperText={form.errors.title}
			/>
			<Stack mt={2}>
				{ savedCalendar && <ModelView
					attributes={[
						{ label: "ID", value: (calendar.id <= 0 ? "p" : "") + Math.abs(calendar.id) },
						{ label: "Created By", value: savedCalendar?.createdByEmployee ? savedCalendar?.createdByEmployee.displayName + " (" + savedCalendar?.createdBy + ")" : savedCalendar?.createdBy, hidden: !savedCalendar },
						{ attribute: "creationDate", format: "datetime" },
						{ attribute: "modifiedDate", format: "datetime" },
						{ label: "Link", value: <Link href={window.location.origin + "/calendar/" + (savedCalendar?.id)}>{window.location.origin + "/calendar/" + savedCalendar?.id}</Link>, hidden: !savedCalendar }
					]}
					model={savedCalendar as Calendar}
					labelSx={{
						pr: 1,
						width: 130,
						textAlign: "right"
					}}
					valueSx={{
						maxWidth: 500,
						maxHeight: 200,
						overflow: "auto"
					}}
					labelTypographyProps={{
						color: "textSecondary",
					}}
				/>}
			</Stack>
		</Stack>
	);

}